// Shared type helpers to be used across components in test analytics

type Entries<T> = {
  [K in keyof T]: [K, T[K]];
}[keyof T][];

// The typing for Object.entries provided by typescript returns type [string, T][] rather then using the key type of obj
export const getEntries = <T extends object>(obj: T) =>
  Object.entries(obj) as Entries<T>;
